export default __webpack_public_path__ + "static/media/RESUME.c308c830.pdf";